import { AxiosResponse } from 'axios'
import { PaymentSessionResponse } from './generated/models'
import apiClient from './apiClient'

export const paymentSessionApi = {
  getPaymentSession: async (sessionId: string): Promise<PaymentSessionResponse> => {
    // Create a client instance without authentication for public endpoint
    const publicApiClient = apiClient.create({
      baseURL: apiClient.defaults.baseURL,
      headers: {
        'Content-Type': 'application/json',
      },
    })

    const response: AxiosResponse<PaymentSessionResponse> = await publicApiClient.get(
      `/api/v1/payment-sessions/${sessionId}`,
    )
    return response.data
  },
}
